var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-navbar', {
    staticClass: "header d-print-none app-header",
    class: {
      'sidebar-collapsed': _vm.sidebarCollapsed
    }
  }, [_c('b-nav', [_c('b-nav-item', {
    staticClass: "menu-toggle",
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('span', {
    staticClass: "fs-lg"
  }, [_c('svg', {
    staticClass: "bi bi-list",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    }
  })])])]), _c('div', {
    staticClass: "logo-container"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo-image-container",
    class: {
      'collapsed-state': _vm.sidebarCollapsed
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.sidebarCollapsed && !_vm.isMobile,
      expression: "!sidebarCollapsed && !isMobile"
    }],
    staticClass: "logo-image first",
    attrs: {
      "src": "/redstone-logo-full.svg"
    }
  })]), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sidebarCollapsed || _vm.isMobile,
      expression: "sidebarCollapsed || isMobile"
    }],
    staticClass: "logo-image collapsed",
    attrs: {
      "src": "/redstone-hex.svg"
    }
  })])], 1)])])], 1), _c('b-form', {
    staticClass: "search-wrapper",
    attrs: {
      "inline": ""
    }
  }, [_c('b-form-group', [_vm.showSearchInputInHeader ? _c('b-input-group', {
    staticClass: "input-group-no-border ml-2",
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function fn() {
        return [_c('b-input-group-text', [_c('i', {
          staticClass: "fi flaticon-search-2"
        })])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_vm.searchTerm ? _c('b-input-group-text', {
          on: {
            "click": _vm.resetSearch
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e()];
      },
      proxy: true
    }], null, false, 1145116244)
  }, [_c('b-form-input', {
    attrs: {
      "id": "search-input",
      "placeholder": "Search..."
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1) : _c('span', {
    on: {
      "click": _vm.safeGoBack
    }
  }, [_c('i', {
    staticClass: "fa flaticon-chevron-back",
    attrs: {
      "role": "button"
    }
  })])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }